import {Center, Box, Text} from '@chakra-ui/react';
import {ResponsiveImageType} from 'react-datocms';
import {DatoCmsImage} from '../datocms/image';

interface FeaturedImageProps {
  background?: string;
  image: ResponsiveImageType;
  caption?: string;
}

export const FeaturedImage: React.FC<FeaturedImageProps> = ({
  image,
  caption,
  background,
}) => (
  <Center bg={background} width="100%">
    <Box
      width="100%"
      maxW={{base: '100%', md: '765px', lg: '975px'}}
      py={{base: '40px', md: '80px'}}
    >
      {image && <DatoCmsImage responsiveImage={image} />}
      {caption && (
        <Text mt={6} textStyle="body3_1c" textAlign="center">
          {caption}
        </Text>
      )}
    </Box>
  </Center>
);
